<template>
  <button :class="className" :disabled="isLoading" :title="in18['page_add_to_wishlist']" class="btn" type="button" @click="toggleWishlist">
    <img :alt="in18['page_add_to_wishlist']" class="img m-auto" src="/shop/images/heart-icon-v1.svg">
  </button>
</template>

<script>
export default {
  props: {
    productId: Number,
    className: {
      type:    String,
      default: '',
    },
    in18: {
      type: Object,
    },
    is_wishlist_page: {
      type:    Boolean,
      default: false
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    toggleWishlist() {

      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      axios.post(`/api/wishlist/toggle/${this.productId}`).then((response) => {
        window.toastr.success(response.data.message);
        ga_add_to_wishlist_event(response.data.product);
        if(this.is_wishlist_page === true) {
          location.reload();
        }
      }).catch((error) => {
        window.toastr.error(error.response.data.message);
      }).finally(() => {
        this.isLoading = false;
      });
    },
  },
};
</script>